<div class="my-inte-form my-interests">
  <form
    class="my-interests_form"
    *ngIf="interestsForm"
    [formGroup]="interestsForm"
    (submit)="onSubmit()"
    novalidate>
    <div class="row">
      <div class="offset-md-4 col-md-4 col-12">
        <a *ngIf="navigationBackButton" class="a-link" (click)="onBack()"
          ><img src="../../../../../assets/icons/arrow-back.svg" alt="Buttons" />
          <span class="a-text">{{ 'buttons.labels.back' | translate }} </span></a
        >
        <h1 class="form-title form-title__bp_lt-md_hidden">
          {{ 'stepper.interest' | translate }}
        </h1>
        <p>
          {{ 'captive.form.my-interest.subtitle1' | translate }}
        </p>
        <div class="form-group" *ngFor="let interest of interests$ | async; let i = index">
          <app-custom-checkbox [label]="interest.name" [formControlName]="interest.id" />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="offset-md-4 col-md-4 col-12">
        <app-button
          class="uppercase"
          type="submit"
          [label]="label"
          [isDisabled]="!interestsForm.valid"
          [className]="'ind-btn--primary'"
          class="ind-btn-wrapper-100" />
      </div>
    </div>
  </form>
</div>
